import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconClock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "#2E2D37",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icon/Clock",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Combined Shape",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.3989 7.60054C11.8469 7.60054 11.3989 8.04854 11.3989 8.60054V12.6005C11.3989 12.7305 11.4249 12.8605 11.4759 12.9825C11.5269 13.1045 11.5999 13.2155 11.6919 13.3085L14.6917 16.3075C14.8867 16.5025 15.1427 16.6005 15.3987 16.6005C15.6547 16.6005 15.9107 16.5025 16.1057 16.3075C16.4967 15.9165 16.4967 15.2845 16.1057 14.8935L13.3988 12.1865V8.60054C13.3988 8.04854 12.9508 7.60054 12.3989 7.60054ZM18.0509 18.2528C14.9319 21.3718 9.85591 21.3718 6.73791 18.2528C3.61791 15.1338 3.61791 10.0588 6.73791 6.93984C9.85591 3.81984 14.9319 3.81984 18.0509 6.93984C21.1699 10.0588 21.1699 15.1338 18.0509 18.2528ZM19.4659 5.52484C15.5659 1.62584 9.22191 1.62584 5.32291 5.52484C1.42491 9.42384 1.42491 15.7678 5.32291 19.6678C9.22191 23.5658 15.5659 23.5658 19.4659 19.6678C23.3639 15.7678 23.3639 9.42384 19.4659 5.52484Z"
		})
	})
});
export default SvgIconClock;
